import { gql } from "@edreamsodigeo/frontend-api-client";

const CommonPriceBreakdownFields = gql`
  fragment CommonPriceBreakdownFields on PriceBreakDownItem {
    type
    discountInfo {
      type
      isApplied
      discount {
        amount
        currency
      }
    }
  }
`;

export const PRICE_BREAKDOWN_PRICE_SUMMARY = gql`
  ${CommonPriceBreakdownFields}
  query GetPriceBreakdownPriceSummary($request: PriceBreakDownRequest!) {
    getCartPriceBreakDown(request: $request) {
      items {
        ...CommonPriceBreakdownFields
        ... on AccommodationPriceBreakDownItem {
          selectedCustomerPriceType
        }
      }
    }
  }
`;
